export default __webpack_public_path__ + "assets/images/Payment_02.645046.png";